import InProgressListPage from '@/modules/FileList/pages/InProgressListPage';
import MyFilesPage from '@/modules/FileList/pages/MyFilesPage';
import NewFilesListPage from '@/modules/FileList/pages/newFilesListPage.tsx';
import { RouteObject } from 'react-router-dom';

export const FileListRoutes: RouteObject[] = [
  {
    index: true,
    element: <></>,
  },
  {
    path: 'new-files',
    element: <NewFilesListPage />,
  },
  {
    path: 'in-progress',
    element: <InProgressListPage />,
  },
  {
    path: 'list',
    element: <MyFilesPage />,
  },
];
